import React, { useEffect, useState } from 'react'

import DnDinput from '../DnDInput'

import apiClient from '../../helpers/apiClient'

import { getFromLocalStorage, parseJSON } from '../../utils/util'

const ProfessionalHeadlinesDnDInput = ({
  currentHeadlines,
  onHeadlinesChange,
  errorMessage,
}) => {
  const [professionalHeadlines, setProfessionalHeadlines] = useState([])

  useEffect(() => {
    getProfessionalHeadlines()
  }, [])

  const getProfessionalHeadlines = () => {
    const cvData = getFromLocalStorage('applicant-cv-data')

    const cachedProfessionalHeadlines =
      parseJSON(cvData?.professional_headline, []) || []

    const allHeadlines = [...currentHeadlines, ...cachedProfessionalHeadlines]

    apiClient
      .get(`/professional-headlines?withSkills=true`)
      .then((res) => {
        let headlines = res?.data?.resp

        let mappedCurrentHeadlineIds = allHeadlines?.map(
          (headline) => headline.value || headline.id
        )
        mappedCurrentHeadlineIds = [...new Set(mappedCurrentHeadlineIds)]

        headlines = headlines?.map((headline) => {
          const headlineTemplate = {
            item: headline.professional_headline,
            id: headline.id,
          }

          if (mappedCurrentHeadlineIds?.includes(headline.id)) {
            headlineTemplate.status = 'moved'
          } else {
            headlineTemplate.status = 'current'
          }

          return headlineTemplate
        })

        setProfessionalHeadlines(headlines)
      })
      .catch((e) => console.log(e))
  }

  return (
    <>
      {professionalHeadlines?.length > 0 && (
        <DnDinput
          values={professionalHeadlines}
          title="Professional Headlines"
          heading="Choose up to 3 keywords to describe yourself professionally"
          dropzoneClassName="professional-headlines-dndinput"
          errorMessage={errorMessage}
          onChange={onHeadlinesChange}
        />
      )}
    </>
  )
}

export default ProfessionalHeadlinesDnDInput
